import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions } from 'components';
import { dateFormat } from 'enums';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var officeListColumns = [{
  name: 'ID',
  render: function render(office) {
    return ___EmotionJSX(Link, {
      to: {
        pathname: "office/details/".concat(office === null || office === void 0 ? void 0 : office.id),
        state: {
          office: office
        }
      }
    }, office === null || office === void 0 ? void 0 : office.id);
  },
  width: '60px'
}, {
  name: 'Име',
  value: 'name'
}, {
  name: 'Адрес',
  value: 'address'
}, {
  name: 'Кредитен поср.',
  value: 'franchisee.name'
}, {
  name: 'Създаден на',
  value: 'created_at',
  dateTimeFormat: dateFormat,
  width: '120px'
}, {
  name: '',
  render: function render(office) {
    return ___EmotionJSX(TableActions, {
      mainAction: {
        linkTo: {
          pathname: "/office/details/".concat(office === null || office === void 0 ? void 0 : office.id),
          state: {
            office: office
          }
        },
        leftIcon: {
          iconName: 'la la-info',
          size: 20
        },
        css: detailsBtn
      }
    });
  },
  width: '50px'
}].filter(Boolean);